import {Component, OnInit} from '@angular/core';
import {CurrentRouteService} from '../currentRoute.service';
import {Router, ActivatedRoute, ParamMap} from '@angular/router';
import {AccountIdService, AgencyIdService} from "../account.service";

import {ThemePalette} from '@angular/material/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit {

  agency_id: string;
  account_id: string;
  asb_sub: any;
  acb_sub: any;
  links: any;
  report_type: string;
  filter$: Observable<string>;

  background: ThemePalette = 'accent';
  activeLink: any;

  toggleBackground() {
    this.background = this.background ? undefined : 'primary';
  }

  addLink() {
    this.links.push(`Link ${this.links.length + 1}`);
  }

  constructor(public router: Router,
              private route: ActivatedRoute,
              private agencyidService: AgencyIdService,
              private accountidService: AccountIdService,
              private currentrouteService: CurrentRouteService,) {
  }

  ngOnInit(): void {

    this.currentrouteService.announceCurrentRoute(this.router.url);

    this.route.params.subscribe(parms => {
      this.agency_id = parms['agency_id'],
        this.account_id = parms['account_id'],
        this.agencyidService.announceAgencyId(this.agency_id);
      this.accountidService.announceAccountId(this.account_id);
      console.log(this.route.snapshot.queryParamMap)
    });

    this.filter$ = this.route.queryParamMap.pipe(
      map((params: ParamMap) => params.get('type')),
    );
    this.filter$.subscribe(param => {
      this.report_type = param;
      //be carefull here make sure we have a report_type
      if (this.report_type) {
        this.links = [];
        this.createLinks(this.report_type);
      }
    });
  } //end ngOnInit


  is_trigger = false;
  is_outcome = false;
  is_explore = true;
  createLinks(report_type) {

    //  [queryParams]="{network: googleads}"
    if (report_type == 'performance') {
      this.links = [
        {
          "name": "Ad Networks",
          "link": [{outlets: {report: ['campaigns', 'google', `${this.agency_id}`, `${this.account_id}`]}}]
        },
        {
          "name": "Actions",
          "link": [{outlets: {report: ['campaigns', 'actions', `${this.agency_id}`, `${this.account_id}`]}}]
        },
        // {
        //   "name": "Actions Paging",
        //   "link": [{outlets: {report: ['campaigns', 'actions-paging', `${this.agency_id}`, `${this.account_id}`]}}]
        // },
        {
          "name": "Attributions",
          "link": [{outlets: {report: ['campaigns', 'attribution', `${this.agency_id}`, `${this.account_id}`]}}]
        },
        // {
        //   "name": "Facebook",
        //   "link": [{outlets: {report: ['campaigns', 'facebook', `${this.agency_id}`, `${this.account_id}`]}}]
        // },
      ] //end links
    } //end performance'
  } //end createLinks()

  //@Output() isActiveChange: EventEmitter<boolean>
  isActiveChange(event) {
    console.log(event)
  }


}//end class
